import api from './_api';
import Vue from 'vue'


const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id        
    try{        
        var response = await api.postForm(result,id)
        if (response) {                                         
            await context.dispatch('getAll');
            context.commit('ENTITY_SET_DUPLICATE', false)
            return response
        }
    }
    catch(error)  {          
        return Promise.reject(error);
    };    
};
        
const getAll = async (context) => {
    try {
        var response = await api.fetchAll()                
        context.commit('ENTITY_SET_ENTITIES',response.data)          
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error)
    };    
};

const recursiveentities =({dispatch,commit,getters,rootGetters},payload) => {
            if(!Array.isArray(payload.needle) 
            || !Array.isArray(rootGetters['recipesteps/recipesteps'])
            || !Array.isArray(getters['entities']) 
            || !Array.isArray(payload.res)){                
                return []
            }
            let needle=payload.needle
            let res = payload.res
            if(needle.length == 0) {              
                return getters['entities'].filter(b=>!res.flat().includes(b.id))
            }            
            res.push(needle)
            needle=[...new Set(rootGetters['recipesteps/recipesteps'].filter(a=>needle.includes(a.ingredient_id)).map(a => a.entity_id))]            
            return dispatch('recursiveentities',{needle:needle,res:res})
        }


const forrecipe = async (context,payload) => {
    try {        
        
        await context.dispatch('recipesteps/getAll',null,{root:true})
        await context.dispatch('getAll')
        var response = await context.dispatch('recursiveentities',payload)  
        
        context.commit('ENTITY_SET_INGREDIENTS',response)           
        return response
    }
    catch(error) {                        
        return Promise.reject(error)
    };    
};

const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('ENTITY_SET_ENTITY',response.data)           
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error)
    };    
};

const deleteById = async (context,payload) => {
    
    try {             
        var response = await api.deleteById(payload)     
        await context.dispatch('getAll')           
        return response.data
    }
    catch(error) {           
        return Promise.reject(error)
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById,  
  forrecipe,
  recursiveentities
};
